module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-2-2333b5a09c4b69c3d3fa887610883fda.svg";